import React from 'react';
import '../../../App.css';
import ProfileViewer from '../../../components/profile/ProfileViewer';
import { ThemeProvider } from '../../../theme/ThemeContext';

function ProfilePage() {
  return (
    <ThemeProvider>
      <div className="App">
        <ProfileViewer />
      </div>
    </ThemeProvider>

  );
}

export default ProfilePage;
